export default "__VITE_ASSET__Gwkrp2nx__ 1034w, __VITE_ASSET__dLVyaTqj__ 767w, __VITE_ASSET__ZcIBZUVf__ 500w";